// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2qM5V","productName":"Table_productName__JRiHi"};